import React from 'react';
import { Activity, ActivityEditorProps } from '../types';
import { ActivityInfo } from '../ActivityCommon';

// Default Editor Component
const DefaultEditor: React.FC<ActivityEditorProps> = ({ activity }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">{activity.type.charAt(0).toUpperCase() + activity.type.slice(1)} Editor</h3>
      <ActivityInfo activity={activity} />
      <div className="mt-4 p-4 border border-gray-200 rounded-md">
        <p className="text-sm text-gray-500">Editor for this activity type is not yet implemented.</p>
      </div>
    </div>
  );
};

export default DefaultEditor; 